import { Link } from 'react-router-dom';
import { categories } from '@/mocks/anime';

export default function CategoryGrid() {
  return (
    <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="text-center mb-8 md:mb-10">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-50">
          <i className="ri-apps-2-line text-accent-400 mr-2"></i>内容分类
        </h2>
        <p className="text-sm text-foreground-400 mt-2 max-w-xl mx-auto">
          按类别浏览您感兴趣的内容，发现更多精彩作品
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.slug}`}
            className="flex flex-col items-center p-5 md:p-6 rounded-lg bg-background-100 hover:bg-background-200/70 border border-background-200/50 hover:border-accent-500/30 transition-all cursor-pointer group"
          >
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-accent-500/10 flex items-center justify-center mb-3 group-hover:bg-accent-500/20 transition-colors">
              <i className={`${cat.icon} text-xl md:text-2xl text-accent-400`}></i>
            </div>
            <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-100 mb-1 whitespace-nowrap">
              {cat.name}
            </h3>
            <p className="text-xs text-foreground-500 text-center line-clamp-2">
              {cat.description}
            </p>
          </Link>
        ))}
      </div>
    </section>
  );
}